import Typography from "./overrides/Typography";
import Palette from "./overrides/Palette";
import { createTheme, Theme } from "@mui/material";

export interface IAppTheme {
  primary: string;
  primaryContrast: string;
  textPrimary: string;
  secondary: string;
  secondaryContrast: string;
}

export const DefaultTheme: IAppTheme = {
  primary: "#4caf50",
  primaryContrast: "#ffffff",
  textPrimary: "#2b2f3d",
  secondary: "#2b2f3d",
  secondaryContrast: "#4caf50",
};

const theme = (appTheme: IAppTheme = DefaultTheme): Theme =>
  createTheme({
    spacing: 4,
    palette: Palette(appTheme),
    typography: Typography,
  });

export default theme;
